import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sw_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['Content-Type'] = 'application/json';
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("sw_token");
      localStorage.removeItem("sw_user");
      const path = window.location.pathname;
      const isMarketingPage = ["/", "/about", "/features", "/pricing", "/contact"].includes(path) ||
                              path.startsWith("/login") ||
                              path.startsWith("/register");
      if (!isMarketingPage) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
